import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { SiteGate } from "@/components/SiteGate";
import { track } from "@/lib/analytics";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Bundles from "@/pages/Bundles";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import FAQ from "@/pages/FAQ";
import Standards from "@/pages/Standards";
import { Terms, ReturnPolicy } from "@/pages/Legal";

function StoreLayout({ children }) {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    track("pageview");
  }, [pathname]);
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
        else window.scrollTo(0, 0);
      }, 60);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return (
    <>
      <Navbar />
      <CartDrawer />
      <SiteGate />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function AppRoutes() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }

  return (
    <StoreLayout>
      <Routes>
        <Route path="/" element={<Shop />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/bundles" element={<Bundles />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/standards" element={<Standards />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/returns" element={<ReturnPolicy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </StoreLayout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <AppRoutes />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                borderRadius: 0,
                border: "1px solid #000",
                background: "#000",
                color: "#fff",
                fontSize: "12px",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
              },
            }}
          />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
